import React, { useEffect, useRef, useState } from "react"

/**
 * @type {React.FC<React.PropsWithChildren<{
 *  in:boolean
 *  onTransitionEnd?: () => void
 * }>>}
 */
const Collapse = ({ children, in: wantCollapse, onTransitionEnd }) => {
  /** @type {React.MutableRefObject<HTMLDivElement>} */
  const ref = useRef(undefined)
  // state for actually collapsed or not
  const [collapsed, setCollapsed] = useState(wantCollapse)
  // state for transitioning or not
  const [isCollapsing, setIsCollapsing] = useState(false)
  useEffect(() => {
    // if (isCollapsing) {
    //   return
    // }
    function handleEnter() {
      const el = ref.current
      if (el) {
        // current event loop
        el.style.height = "auto"
        const fullHeight = el.clientHeight
        el.style.height = "0"
        el.style.willChange = "height"

        // next event loop
        requestAnimationFrame(() => {
          el.style.height = String(fullHeight) + "px"
        })
      }
    }
    function handleLeave() {
      const el = ref.current
      if (el) {
        el.style.height = String(el.clientHeight) + "px"
        requestAnimationFrame(() => {
          el.style.height = "0"
          el.style.willChange = ''
        })
      }
    }

    // handle is need to start Transition or not
    if (wantCollapse !== collapsed) {
      setIsCollapsing(true)
      if (wantCollapse === false) {
        handleEnter()
      } else {
        handleLeave()
      }
    } else {
      handleLeave()
      setIsCollapsing(false)
    }
  }, [collapsed, wantCollapse])

  /**
   * @type {React.TransitionEventHandler<HTMLDivElement>}
   */
  const handleTransitionEnd = e => {
    if (e.propertyName !== "height") {
      return
    }
    setCollapsed(prev => prev = !prev)
    if (wantCollapse !== collapsed) {
      setIsCollapsing(false);
    } else {
      setIsCollapsing(true);
    }
    onTransitionEnd && onTransitionEnd()
  }
  return (
    <div
      ref={ref}
      className={
        isCollapsing ? "collapsing" : collapsed ? "collapse" : "collapse show"
      }
      onTransitionEnd={handleTransitionEnd}>
      {children}
    </div>
  )
}

export default Collapse
